export default {
  namespaced: true,
  state: {
    showUploadPdfModal: false,
    showDocumentDetailsModal: false,
    showAssignedModal: false
  },
  mutations: {
    UPDATE_SHOW_UPLOAD_PDF_MODAL(state, payload) {
      state.showUploadPdfModal = payload;
    },
    UPDATE_SHOW_DOCUMENT_DETAILS_MODAL(state, payload) {
      state.showDocumentDetailsModal = payload;
    },
    UPDATE_SHOW_ASSIGNED_MODAL(state, payload) {
      state.showAssignedModal = payload;
    }
  },
  actions: {}
};
